// Items 43/49 (SYSTEM.debt.md): the effect that builds ContentTable's rows
// only rebuilt when `selectedGroupId` changed (via `groupUseForBuiltTable`)
// — a `companyId` change (filtering a different Company, or a different
// role viewing the same Company) never triggered a rebuild once
// `contentSet` was already true, leaving the table frozen on stale data.
// Pulled out as a pure function so the skip/rebuild decision is
// unit-testable without mocking the dozens of Redux selectors the
// component itself depends on.
export interface IShouldSkipRebuildParams {
  contentSet: boolean;
  groupsChildrenSet: boolean;
  coursesCount: number;
  studentIdPerGroupCount: number;
  groupUseForBuiltTable: string;
  selectedGroupId: string | undefined;
  companyUsedForBuiltTable: string;
  companyId: string;
}

export const shouldSkipRebuild = ({
  contentSet,
  groupsChildrenSet,
  coursesCount,
  studentIdPerGroupCount,
  groupUseForBuiltTable,
  selectedGroupId,
  companyUsedForBuiltTable,
  companyId,
}: IShouldSkipRebuildParams): boolean => {
  const alreadyBuiltOrNotReady = contentSet
    || !groupsChildrenSet
    || coursesCount === 0
    || studentIdPerGroupCount === 0;
  // Preserves the pre-existing comparison exactly as it was before this
  // fix (string vs. string|undefined, no normalization) — not the concern
  // of this fix, changing it could alter unrelated existing behavior.
  const sameGroup = groupUseForBuiltTable === selectedGroupId;
  const sameCompany = companyUsedForBuiltTable === companyId;
  return alreadyBuiltOrNotReady && sameGroup && sameCompany;
};
